<template>
    <div class="error-div">
        <v-container>
            <v-img
            :src="require('../assets/logo-uys.png')"
            class="my-5"
            contain 
            height="50" 
            />
            <h3 class="mb-3">Compte inactif</h3>
            <p class="mb-3">Votre compte n'a pas encore été activé</p>
            <v-btn
                depressed
                color="primary"
                outlined
                rounded
                class="mt-3"
                @click="disconnect"
            >Se connecter</v-btn>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'ErrorInactive',
    methods: {
        disconnect() {
            this.$store.dispatch('getDisconnected', {})
            this.$router.push({ name: 'Login' })
        }
    },
}
</script>
<style lang="scss">
    .error-div {
        //background-color: #eb566b;
        height:100vh;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align:center;
        .v-image {
            height:20vh
        }
    }
</style>